// App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "./MainPage";
import RetrievePage from "./RetrievePage";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Route for decryption page: expects both a uuid and a password */}
        <Route
          path="/retrieve-cypher/:uuid/:password"
          element={<RetrievePage />}
        />
        {/* Any other URL will lead to the main page */}
        <Route path="*" element={<MainPage />} />
      </Routes>
    </Router>
  );
};

export default App;
